var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.FieldDate,{ref:"dateRef",attrs:{"state-key":_setup.usingStateKey,"custom-disabled-date":_setup.customDisabledDate}},[_c('i',{staticClass:"iconfont-midea iconcalendar",attrs:{"slot":"suffix"},slot:"suffix"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }